import Head from 'next/head';
import Link from 'next/link';
import React from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { KaimonoWebRoutes } from 'src/config/routes';
import type { BreadcrumbItem } from '.';
import styles from './index.module.scss';

type Props = {
  items: BreadcrumbItem[];
  jsonLdMarkup: string;
  isHomePage?: boolean;
};

export const Presenter: React.FC<Props> = ({ items, jsonLdMarkup, isHomePage }) => {
  return (
    <div className={styles.NavigatorAreaOuter}>
      <Head>
        <script key="ldjson" type="application/ld+json">
          {jsonLdMarkup}
        </script>
      </Head>
      {!isHomePage && (
        <ul className={styles.container} data-testid="breadcrumb">
          <li className={styles.homeIconContainer}>
            <Link href={KaimonoWebRoutes.index}>
              <a className={styles.home}>
                <NextImage src="/kaimono/images/common/navigator/home.webp" alt="home" width={13} height={12} />
              </a>
            </Link>
          </li>
          {items?.slice(0, items.length - 1).map(({ unprefixedPath, label, waWebRoutes }, index) => (
            <li key={index} className={styles.list}>
              <Link href={unprefixedPath}>
                <a
                  className={styles.label}
                  onClick={(e) => {
                    if (waWebRoutes) {
                      e.preventDefault();
                      window.location.href = unprefixedPath;
                    }
                  }}
                >
                  {label}
                </a>
              </Link>
            </li>
          ))}
          <li className={styles.list}>
            <span className={styles.ellipsis}>{items?.slice(-1)[0].label}</span>
          </li>
        </ul>
      )}
    </div>
  );
};
